import clsx from "clsx";

type Props = {
  label: string;
  dimmed?: boolean;
};

export const SelectedInfoBadge = ({ label, dimmed }: Props) => (
  <div
    className={clsx(
      "w-fit rounded-lg border border-stroke-neutral-soft bg-surface-background px-2 py-1 text-xs font-medium",
      {
        "text-text-disabled-primary": dimmed,
        "text-text-primary": !dimmed,
      },
    )}
  >
    {label}
  </div>
);
